import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SEND_CODE,
  REFRESH_TOKEN_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("userData"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        data:payload
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        errors:payload.errors,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case REFRESH_TOKEN_SUCCESS:
      let data={ ...state,
        isLoggedIn: true,
        user: payload}
      return data;
    case SEND_CODE:
      return state;
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state
      }
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state
      }
    default:
      return state;
  }
}
